export const notifyCoreID = (fields, idNumber) => {
  let jsonPayload = JSON.stringify({
    ...{ subscriber: "fa218eab-4767-4089-a704-c08e02852532" },  // TODO: this is the M+ subscriber can need to depend on passed in subscriber id value going forward
    ...{ changes: fields }
  })

  const encoded_credentials = window.btoa(`${process.env.REACT_APP_COREID_USER}:${process.env.REACT_APP_COREID_PASS}`)

  fetch(`${process.env.REACT_APP_API_ROOT}/coreid/change/${idNumber}/`, {
    method: 'post',
    headers: {
      'Authorization': `Basic ${encoded_credentials}`,
      'Content-Type': 'application/json'
    },
    body: jsonPayload
  })
  .then(response => response.json())
  .then(data => {
    console.log('Success:', data)
  })
  .catch(error => {
    console.log('Update to CoreID failed', error)
    // should we add retry logic?  (if we want to be fancy in the future we can use celery)
  })
}



// WEBPACK FOOTER //
// ./src/utils/coreid/index.js